<form [formGroup]="registerForm" (ngSubmit)="submitForm()">
  <div class="md:flex md:gap-4 md:mb-8">
    <p-float-label class="w-full mb-8 md:mb-0">
      <input [id]="id + 'name'" pInputText type="text" formControlName="name"
        [pTooltip]="formWatched['children']['name']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
        required class="w-full" />
      <label [for]="id + 'name'">Nome</label>
    </p-float-label>

    <p-float-label class="w-full mb-8 md:mb-0">
      <input [id]="id + 'sobrenome'" pInputText type="text" formControlName="lastName"
        [pTooltip]="formWatched['children']['lastName']() | formFieldFeedback" tooltipEvent="focus"
        tooltipPosition="bottom" class="w-full" required />
      <label [for]="id + 'sobrenome'">Sobrenome</label>
    </p-float-label>
  </div>
  <div class="md:flex md:gap-4 md:mb-8">
    <div class="mb-8 md:mb-0 w-full">
      <p-float-label>
        <p-datepicker [id]="id + 'data'" appendTo="body" formControlName="birthdate" dateFormat="dd/mm/yy"
          [pTooltip]="formWatched['children']['birthdate']() | formFieldFeedback" [maxDate]="today" tooltipEvent="hover"
          required />
        <label [for]="id + 'data'">Data de Nascimento</label>
      </p-float-label>
    </div>
    <div class="mb-8 md:mb-0 w-full">
      <p-float-label>
        <p-inputmask [id]="id + 'telefone'" type="tel" mask="(99) 99999-9999"
          [pTooltip]="formWatched['children']['phone']() | formFieldFeedback" formControlName="phone" />
        <label [for]="id + 'telefone'">Telefone</label>
      </p-float-label>
    </div>
  </div>
  <p-float-label class="w-full mb-8">
    <input [id]="id + 'email'" pInputText type="email" formControlName="email"
      [pTooltip]="formWatched['children']['email']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
      required class="w-full" />
    <label [for]="id + 'email'">E-mail</label>
  </p-float-label>
  @if(initialData()) {

  <div class="mb-8 flex justify-end">
    <p [ngClass]="{
        'text-green-500': isChangePasswordEnabled(),
        'text-gray-400': !isChangePasswordEnabled()
      }" class="font-semibold mr-2">
      {{ isChangePasswordEnabled() ? "Trocar a senha" : "Manter a senha" }}
    </p>
    <p-toggleswitch [(ngModel)]="isChangePasswordEnabled" [ngModelOptions]="{ standalone: true }" />
  </div>
  } @if (isChangePasswordEnabled() || !initialData()){
  <div class="md:flex md:gap-4 md:mb-16">
    <div class="mb-8 md:mb-0 w-full">
      <p-float-label>
        <p-password [id]="id + 'senha'" formControlName="password" promptLabel="Escolha uma senha"
          weakLabel="Muito simples" mediumLabel="Complexidade média" strongLabel="Senha forte" [toggleMask]="true"
          [pTooltip]="formWatched['children']['password']() | formFieldFeedback" tooltipEvent="hover"
          tooltipPosition="right" />
        <label [for]="id + 'senha'">Senha</label>
      </p-float-label>
    </div>
    <div class="mb-16 md:mb-0 w-full">
      <p-float-label>
        <p-password [id]="id + 'confirmacao'" formControlName="confirmPassword" promptLabel="Escolha uma senha"
          weakLabel="Muito simples" mediumLabel="Complexidade média" strongLabel="Senha forte" [toggleMask]="true"
          [pTooltip]="formWatched['children']['confirmPassword']() | formFieldFeedback" tooltipEvent="hover"
          tooltipPosition="right" />
        <label [for]="id + 'confirmacao'">Confirme a senha</label>
      </p-float-label>
    </div>
  </div>
  @if(formWatched["group"]().errors){
  <div class="border-red-500 border-2 bg-red-100 text-red-500 p-2 mb-8 rounded-md">
    {{ formWatched["group"]() | formFieldFeedback }}
  </div>

  } }
  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>